import React, { Component, PropTypes } from 'react';
import {
  formatPenceToPounds,
} from 'utils/utils';
import './BookPrice.scss';

export default class BookPrice extends Component {
  static propTypes = {
    className: PropTypes.string,
    divisor: PropTypes.number,
    hasCurrencySymbol: PropTypes.bool,
    hasSmallSuffix: PropTypes.bool,
    isRounded: PropTypes.bool,
    isStacked: PropTypes.bool,
    isStrikeThrough: PropTypes.bool,
    isStrong: PropTypes.bool,
    prefix: PropTypes.string,
    price: PropTypes.number.isRequired,
    suffix: PropTypes.string,
  };

  static defaultProps = {
    hasCurrencySymbol: true,
    hasSmallSuffix: false,
    isStacked: false,
    isStrikeThrough: false,
    className: '',
    isStrong: true,
  };

  dividedPrice(price) {
    const { divisor } = this.props;
    return (price / divisor).toFixed(2);
  }

  formatPrice(price) {
    const {
      divisor,
      hasCurrencySymbol,
      isRounded,
    } = this.props;

    const bookPrice = divisor ? this.dividedPrice(price) : price;
    const decimalPlace = isRounded ? 0 : 2;
    return formatPenceToPounds(bookPrice, decimalPlace, hasCurrencySymbol);
  }

  render() {
    const {
      hasSmallSuffix,
      isStacked,
      isStrikeThrough,
      isStrong,
      prefix,
      price,
      suffix,
      className,
    } = this.props;

    return (
      <span className={`book-price ${isStrikeThrough ? 'book-price--strikethrough' : ''} ${className}`}>
        { isStrong ? (
          <strong className={'book-price__price book-price__price--strong'}>{prefix}{this.formatPrice(price)}</strong>
        ) : (
          <span className="book-price__price">{prefix}{this.formatPrice(price)}</span>
        ) }
        { suffix && (
          <span className={`book-price__suffix ${hasSmallSuffix ? 'book-price__suffix--small' : ''} ${isStacked ? 'book-price__suffix--is-stacked' : ''}`}> {suffix}</span>
        )}
      </span>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/BookPrice/BookPrice.jsx
 **/